import React, { useEffect } from "react"
import { Box, Paper, Stack, Typography } from "@mui/material"
import { useTheme } from '@mui/material/styles'

const lightyellow = '#fff9c4'
const lightblue = '#e3f2fd'
const lightgreen = '#e8f5e9'
const lightpink = '#ffebee'

const darkyellow = '#5f4b00'
const darkblue = '#0d47a1'
const darkgreen = '#1b5e20'
const darkpink = '#880e4f'


export default function Contact(props) {
    const theme = useTheme()

  return (
    <Paper>
      <Stack spacing={3} sx={{ px: {xs: '1rem', sm: '4rem'}, py: '2rem' }}>
        <Typography variant='h4'>Contact</Typography>
        <Typography variant='body1'>
          Feature requests? Questions? Feedback? Comments? Suggestions? I'd love to hear from you! Please feel free to reach out to me at <a href="mailto:contact@gearsofjoy.com">contact@gearsofjoy.com</a>.
        </Typography>


        <Typography variant='body1'>
          I hope to see you on a ride soon!
        </Typography>
      </Stack>
    </Paper>
  )
}
